module.exports = __webpack_public_path__ + "img/kudo-empty.1373d30a.png";